import React from 'react'
import { REACT_APP_MAIL_DIRECTION } from '../../config/settings/environment'
import { GridContainer, GridItem, MailLink, Root, Subtitle, Title } from './CantFindDataForm.styles'

/**
 * The CantFindDataForm's container.
 */
const CantFindDataForm = () => {
  return (
    <Root>
      <GridContainer padding="43px 0 7px">
        <GridItem xs={12}>
          <Title>¿No encuentras los datos que necesitas?</Title>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 21px">
        <GridItem xs={12}>
          <Subtitle>Contáctanos a través de nuestro correo electrónico</Subtitle>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 43px">
        <GridItem align="center" xs={12}>
          <MailLink href={REACT_APP_MAIL_DIRECTION}>datosabiertos@chilecompra.cl</MailLink>
        </GridItem>
      </GridContainer>
    </Root>
  )
}

export default CantFindDataForm
